import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'onefaceui-react-components';
import { getResourceTo, checkIfDataExist, formatDate } from 'react/utils/utils';
import resources from './resources';

const ticketStatusControl = {
  OPEN: {
    name: 'OPEN',
    headerStyle: 'open-status',
    resource: resources.statusOpen
  },
  RE_ASSIGNED: {
    name: 'RE_ASSIGNED',
    headerStyle: 'reassigned-status',
    resource: resources.statusReassigned
  },
  WAITING_SERVICE: {
    name: 'WAITING_SERVICE',
    headerStyle: 'reassigned-status',
    resource: resources.statusReassigned
  },
  ASSIGNED: {
    name: 'ASSIGNED',
    headerStyle: 'assigned-status',
    resource: resources.statusAssigned
  },
  CLOSED: {
    name: 'CLOSED',
    headerStyle: 'closed-status',
    resource: resources.statusClosed
  },
  REOPENED: {
    name: 'REOPENED',
    headerStyle: 'open-status',
    resource: resources.statusReopened
  }
};

const renderIfDataExist = (resource, data) => {
  if (data) {
    return (
      <div className="ticketHub__list-item-data">
        {`${getResourceTo(resource)}: ${data}`}
      </div>
    );
  }

  return null;
};

const setWhatTicketStatusIs = (ticketStatus) => ({
  isTicketClosed: ticketStatus === ticketStatusControl.CLOSED.name,
  isTicketOpen: ticketStatus === ticketStatusControl.OPEN.name,
  isTicketReAssigned: ticketStatus === ticketStatusControl.RE_ASSIGNED.name
    || ticketStatus === ticketStatusControl.WAITING_SERVICE.name,
  isTicketAssigned: ticketStatus === ticketStatusControl.ASSIGNED.name,
  isTicketReopened: ticketStatus === ticketStatusControl.REOPENED.name
});

function TicketHubListItem(props) {
  const {
    ticket,
    acceptTicketAction,
    toggleModalReassignTicket,
    seeTicketInWindow,
    userId
  } = props;

  const ticketStatus = ticket.get('ticketStatus');
  const status = setWhatTicketStatusIs(ticketStatus);

  const getTicketInChatFormat = () => {
    const ticketId = ticket.get('id');
    const ticketTypeId = ticket.getIn(['ticketType', 'id']);
    const ticketRouteKey = ticket.getIn(['ticketLinked', 'route', 'key']);
    const ticketStopDescription = ticket.getIn(['ticketLinked', 'location', 'description']);
    const created = ticket.get('created');

    return ticket.merge({
      ticketId,
      ticketTypeId,
      status: ticketStatus,
      routeKey: ticketRouteKey,
      stopDescription: ticketStopDescription,
      createdDate: created,
      fromTicketHub: true
    });
  };

  const handleAcceptTicket = () => {
    const parsedTicket = getTicketInChatFormat();

    acceptTicketAction(parsedTicket);
  };

  const handleReassign = () => {
    const parsedTicket = getTicketInChatFormat();

    toggleModalReassignTicket(parsedTicket);
  };

  const openChatWindow = () => {
    const parsedTicket = getTicketInChatFormat();

    const ticketTitle = ticket.get('title');
    const userCreatedId = ticket.getIn(['userCreated', 'id']);
    const userName = ticket.getIn(['userCreated', 'name']);

    const dataToOpenNewChat = {
      ...parsedTicket.toJS(),
      userName,
      ticketTitle,
      userId: userCreatedId
    };

    seeTicketInWindow(dataToOpenNewChat);
  };

  const handleSeeTicket = () => {
    const isATicketFromLoggedUser = status.isTicketAssigned
      && ticket.getIn(['userAssigned', 'id']) === userId;

    if (isATicketFromLoggedUser) {
      openChatWindow();
    } else {
      window.location.href = `/#/ticket/details/${ticket.get('id')}`;
    }
  };

  const renderHeaderItem = (whenStatusChanged) => {
    const statusConfig = ticketStatusControl[ticketStatus];
    let date;
    if (!status.isTicketClosed) {
      date = formatDate(whenStatusChanged);
    }

    return (
      <div className={`ticketHub__list-item-header ${statusConfig.headerStyle}`}>
        <span className="ticketHub__list-item-title">{getResourceTo(statusConfig.resource)}</span>
        <span className="ticketHub__list-item-date">{date}</span>
      </div>
    );
  };

  const renderFooterItem = () => {
    let dataToShow;
    if (status.isTicketClosed) {
      const whenStatusChanged = ticket.get('whenStatusChanged') || ticket.get('modified');
      const changedDate = checkIfDataExist(whenStatusChanged);

      dataToShow = formatDate(changedDate);
    }

    if (status.isTicketOpen || status.isTicketReopened) {
      dataToShow = (
        <Button type="primary" className="addItem" onClick={handleAcceptTicket}>
          {getResourceTo(resources.itemButtonAccept)}
        </Button>
      );
    }

    if (status.isTicketReAssigned) {
      dataToShow = (
        <>
          <Button
            type="secondary"
            class="btn-secondary addItem"
            onClick={handleReassign}
          >
            {getResourceTo(resources.itemButtonReAssign)}
          </Button>
          <Button type="primary" className="addItem" onClick={handleAcceptTicket}>
            {getResourceTo(resources.itemButtonAccept)}
          </Button>
        </>
      );
    }

    if (status.isTicketAssigned) {
      dataToShow = (
        <Button type="primary" className="addItem" onClick={handleSeeTicket}>
          {getResourceTo(resources.itemButtonViewTicket)}
        </Button>
      );
    }

    return (
      <div className="ticketHub__list-item-footer">
        {dataToShow}
      </div>
    );
  };

  const renderAttendend = (userAssigned) => {
    if (status.isTicketClosed || status.isTicketAssigned) {
      return renderIfDataExist(resources.itemAttendendByLabel, userAssigned);
    }

    return null;
  };

  return (
    <div className={`ticketHub__list-item ${status.isTicketClosed ? 'statusClosed' : ''}`}>
      {status.isTicketOpen
        ? renderHeaderItem(checkIfDataExist(ticket.get('created')))
        : renderHeaderItem(checkIfDataExist(ticket.get('whenStatusChanged')))}

      <div className="ticketHub__list-item-content">
        <div className="ticketHub__list-item-ticketType">
          {ticket.get('title')}
        </div>
        <div className="ticketHub__list-item-driver">
          {ticket.getIn(['userCreated', 'name'])}
        </div>

        {renderIfDataExist(resources.itemRouteLabel, ticket?.getIn(['ticketLinked', 'route', 'key']))}
        {renderIfDataExist(resources.itemStopLabel, ticket?.getIn(['ticketLinked', 'location', 'description']))}
        {renderAttendend(ticket.getIn(['userAssigned', 'name']))}
      </div>

      {renderFooterItem()}
    </div>
  );
}

TicketHubListItem.propTypes = {
  ticket: PropTypes.object.isRequired,
  acceptTicketAction: PropTypes.func.isRequired,
  toggleModalReassignTicket: PropTypes.func.isRequired,
  seeTicketInWindow: PropTypes.func.isRequired,
  userId: PropTypes.number
};

TicketHubListItem.defaultProps = {
  userId: 0
};

export default React.memo(TicketHubListItem);
